<template>
  <div class>
    <!-- <section v-for="(item, index) in subBody"
             :key="index"
             @click="choose(item)">

      <div class="divimg">{{ item.NAME | cutName }}</div>
      <div class="divInfo">
        <p class="divname">{{ item.NAME }}</p>
        <p>{{ item.DEPTID }}</p>
      </div>
      <div class="divwork">
        <p>{{ item.DEPT_DESCR }}</p>
        <p>{{ item.POSN_DESCR }}</p>
      </div>
    </section> -->
    <!-- <div class="divimg"><img :src="item.Photo"
           alt="" /></div> -->
  </div>
</template>
 
<script>
export default {
  props: ['subBody'],
  methods: {
    choose(item) {
      this.$emit('chooseItem', item)
    },
  },
  filters: {
    cutName(val) {
      return val.slice(0, 1)
    },
  },
}
</script>
 
<style lang = "less" scoped>
section {
  height: 55px;
  background: white;
  font-size: 13px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  div {
    margin: 9px;
    p {
      color: #8f8f8f;
    }
    .divname {
      color: black;
      font-size: 15px;
    }
  }
  .divimg {
    width: 36px;
    height: 36px;
    border: 1px solid #b4b4b4;
    box-sizing: border-box;
    border-radius: 3px;
    img {
      width: 36px;
      height: 36px;
      overflow: hidden;
    }
    text-align: center;
    line-height: 36px;
    font-size: 18px;
    background: rgb(0, 149, 255);
    color: white;
  }
  .divright {
    flex: 1;
    line-height: 55px;
    margin: 0 10px 0 0;
    color: #55a0f8;
    text-align: right;
  }
}
section:last-child {
  border-bottom: 1px solid #e5e5e5;
}
</style>